import React, {
  forwardRef,
  KeyboardEvent,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from "react";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";

interface ApproveFormPopupProps {
  dataSource: any[];
  modalRef?: any;
}

/**
 * 전자결재 양식도움창.
 * 한 메뉴에 결재 양식이 여러 개일 때(예: 국내발주/외화발주) 상신 전에 양식을 고르게 한다.
 * no_form은 선택 결과로만 사용하고 화면에는 nm_title만 노출한다.
 */
const ApproveFormPopup = forwardRef(
  ({ dataSource, modalRef }: ApproveFormPopupProps, ref) => {
    const [columns, setColums] = useState<any>({
      grid1: [],
    });
    const [dataSources] = useState<any>({
      grid1: dataSource,
    });

    const gridRefs = useRef<{ [key: string]: React.RefObject<SnGridRef> }>({
      grid1: React.createRef<SnGridRef>(),
    });

    const getGridCurrent = (key: string): SnGridRef => {
      const grid = gridRefs.current[key]?.current;
      if (!grid) {
        throw new Error(`Grid '${key}' is not mounted yet`);
      }
      return grid;
    };

    useImperativeHandle(ref, () => ({
      getSelectedRow: () => [getGridCurrent("grid1").focusedRowNode().data],
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData("POPUP_FORM");
          setColums({
            grid1: rtn.grid.grid1,
          });
        } catch (error) {}
      };
      fetchform();
    }, []);

    const onModelUpdated = () => {
      getGridCurrent("grid1").setFocusedCell(0, "nm_title");
    };

    const onRowDoubleClicked = () => {
      modalRef.current?.handleConfirm(true);
    };

    const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Enter") {
        e.preventDefault();
        modalRef.current?.handleConfirm(true);
      }
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onModelUpdated: onModelUpdated,
            onRowDoubleClicked: onRowDoubleClicked,
          },
        },
      }),
      [columns, dataSources]
    );

    return (
      <div
        className="h-[350px]"
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minHeight: 0,
          overflow: "hidden",
        }}
        onKeyDown={handleKeyDown}
      >
        <div
          style={{
            flex: 1,
            minHeight: 0,
          }}
        >
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{
              rowSelection: "single",
              isEditable: false,
            }}
            events={grids.grid1.events}
          />
        </div>
      </div>
    );
  }
);

export default ApproveFormPopup;
